<ng-container *ngIf="!loadingIfoodInfo">
  <div *ngIf="showHeader" class="header-loyalty-beneficios">
    <img [src]="'images/ifood-landing/arrow-bold-left.svg' | assetsUrl" (click)="goToBenefits()" (keyup.enter)="goToBenefits()" tabindex="0" alt="Retornar" class="header-loyalty-icon" />
    <span class="header-loyalty-title">Benefícios Passaporte</span>
  </div>
  <div class="header-loyalty-beneficios-cards">
    <div class="header-loyalty-beneficio-card">
      <div class="header-loyalty-beneficio-circle" (click)="goToHighlight()" (keyup.enter)="goToHighlight()" tabindex="0" role="button" aria-label="Destaques">
        <img [src]="'images/ifood-landing/header_loyalty.svg' | assetsUrl" alt="Passaporte" class="header-loyalty-beneficio-img" />
      </div>
      <a class="header-loyalty-beneficio-label" (click)="goToHighlight()" (keyup.enter)="goToHighlight()" tabindex="0">Destaques</a>
    </div>
    <div class="header-loyalty-beneficio-card decolar-ifood">
      <div class="header-loyalty-beneficio-circle">
        <div class="header-loyalty-beneficio-dot"></div>
        <img [src]="'images/ifood-landing/header_ifood.svg' | assetsUrl" alt="iFood" class="header-loyalty-beneficio-img" />
      </div>
      <span class="header-loyalty-beneficio-label">Decolar + iFood</span>
      <div class="decolar-ifood-underline"></div>
    </div>
    <div class="header-loyalty-beneficio-card">
      <div class="header-loyalty-beneficio-circle" (click)="goToCoupons()" (keyup.enter)="goToCoupons()" tabindex="0" role="button" aria-label="Cupons">
        <img [src]="'images/ifood-landing/header_coupon.svg' | assetsUrl" alt="Cupons" class="header-loyalty-beneficio-img" />
      </div>
      <a class="header-loyalty-beneficio-label" (click)="goToCoupons()" (keyup.enter)="goToCoupons()" tabindex="0">Cupons</a>
    </div>
  </div>
</ng-container>
